import React from "react";
import UsersService from "@velocity-ehs/user-utils-module";
import { useHistory } from "react-router-dom";

export const AuthCheck: React.FC = () => {
  const { JWT, customer } = UsersService;
  const history = useHistory();

  React.useEffect(() => {
    setCookieWithDomain("authcheck.jwt", JWT ?? "", 5);
    setCookieWithDomain("authcheck.customerid", customer?.id ?? "", 5);

    const relayState = history.location.search;
    const url = `${process.env.REACT_APP_API_URL}/doauthcheck${relayState}`;
    window.location.replace(url);
    // eslint-disable-next-line
  }, []);

  return <></>;
};

function setCookieWithDomain(name: string, value: string, minutes: number) {
  const expiration = new Date();
  expiration.setTime(expiration.getTime() + minutes * 60 * 1000);
  const expires = `expires=${expiration.toUTCString()}`;
  const domain = `domain=${process.env.REACT_APP_AUTHCHECK_COOKIE_DOMAIN}`;
  document.cookie = `${name}=${value}; ${expires}; ${domain}; path=/`;
}
